import { LoadingSpinner } from '@components/LoadingSpinner.tsx';
import { type PropsWithChildren, useEffect } from 'react';
import {
  ScrollRestoration,
  useLoaderData,
  useNavigation,
} from 'react-router-dom';

export default function Root({ children }: PropsWithChildren) {
  const { state } = useNavigation();
  useLoaderData();

  useEffect(() => {
    const root = document.documentElement;
    root.lang = 'de';
  }, []);

  return (
    <>
      <ScrollRestoration />
      {state !== 'idle' && (
        <LoadingSpinner className="fixed top-2 right-2 !w-6 !h-6" />
      )}
      <div className="flex flex-1 w-full h-full">
        <div data-testid="content" className="w-full bg-gray-100 h-full">
          {children}
        </div>
      </div>
    </>
  );
}
